export const OWNERSHIP_REGISTRATION_CONDITION =
  "متقاضی باید مالک ساختمان محل اجرای پروژه باشد، یا رضایت‌نامه محضری مالک را داشته باشد، یا متعهد شود پس از اخذ آن را در میان مدارک تحویل دهد (رضایت مالک برای احداث نیروگاه).";

export const initialRegistrationConditions = [
  "برای مجتمع‌های آپارتمانی، ارائه رضایت هیئت‌مدیره و معرفی نماینده الزامی است.",
  "متقاضی باید دارای چک صیادی به نام خود باشد.",
  "داشتن کارت پایان خدمت سربازی الزامی است.",
  "داشتن حساب بانک ملت به نام متقاضی الزامی است.",
  "به ازای هر ۵ کیلووات ظرفیت نیروگاه، حداقل ۴۰ متر مربع فضای مناسب برای نصب پنل خورشیدی مورد نیاز است.",
  OWNERSHIP_REGISTRATION_CONDITION,
  "متقاضی باید از نظر اعتبارسنجی بانکی، امکان دریافت تسهیلات/وام را داشته باشد.",
];
